module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('nav', {
    staticClass: "navbar",
    class: [_vm.setType, _vm.setFixed]
  }, [_c('div', {
    class: _vm.setContainer
  }, [(this.name || this.logo) ? _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }, [(!!_vm.logo) ? _c('img', {
    attrs: {
      "alt": _vm.name,
      "src": _vm.logo,
      "height": "20"
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(!_vm.logo ? _vm.name : '') + "\n\t\t\t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_vm._t("nav"), _vm._v(" "), _vm._t("form"), _vm._v(" "), _vm._t("nav-right"), _vm._v(" "), _vm._t("default")], true)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-4b30cee0!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/comp/navbar.vue
// module id = 311
// module chunks = 2